import { useEffect, useState } from "react";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "@/components/ui/dialog";

const CALENDLY_URL = "https://calendly.com/hello-arqeraai/30min";

export const openBookingModal = () => {
  window.dispatchEvent(new Event("arq:open-booking"));
};

export default function ArqBookingModal() {
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const handler = () => setOpen(true);
    window.addEventListener("arq:open-booking", handler);
    return () => window.removeEventListener("arq:open-booking", handler);
  }, []);

  // Build Calendly URL with theming params for dark embed
  const embedUrl = `${CALENDLY_URL}?hide_gdpr_banner=1&background_color=0b0d12&text_color=e8eaed&primary_color=1a6fd4`;

  return (
    <Dialog open={open} onOpenChange={setOpen}>
      <DialogContent className="max-w-[980px] w-[95vw] p-0 bg-arq-surface1 border-arq-border overflow-hidden">
        <DialogHeader className="px-6 pt-6 pb-3 border-b border-arq-border">
          <DialogTitle className="font-display text-arq-text text-[22px]">
            Book an AI Feature Security Review
          </DialogTitle>
          <DialogDescription className="text-arq-muted text-[14px]">
            45 minutes. We map your environment, identify the highest-leverage work,
            and follow up with a written proposal within 48 hours.
          </DialogDescription>
        </DialogHeader>
        <div className="bg-arq-bg" style={{ height: "min(75vh, 720px)" }}>
          {open && (
            <iframe
              src={embedUrl}
              title="Schedule a strategy call with ArqeraAI"
              className="w-full h-full border-0"
              loading="lazy"
            />
          )}
        </div>
      </DialogContent>
    </Dialog>
  );
}
